<template>
  <div>
    {{ layer.name }}
  </div>
</template>

<script>
export default {
  name: "LegendItem",
  props: {
    layer: Object,
  }
}
</script>

<style scoped>
.is-active {
  background-color: aquamarine;
}
</style>